import React from "react";
import { useLocation } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { gtmJoinClick } from "../../utilities/gtm";
import { getString } from "../../utilities";

export default function AdFreeLink() {
  const location = useLocation();

  return (
    <>
      {getString("ads.ad")}

      <a
        href={routeCodes.SUBSCRIBE}
        onClick={() => {
          gtmJoinClick(location.pathname, "advertisement-link");
        }}
      >
        {getString("ads.go")}
      </a>
    </>
  );
}
